
// imports the React library into the component. React is the framework used to build the user interface components.
import React from "react";


//imports the React library into the component. React is the framework used to build the user interface components.
const CommentBox = ({ comments }) => {

  return (

    // This line creates a div element with the class name comment-box. This element will serve as the container for the entire comment box.

  // creates an h3 heading within the comment box, displaying the text "Comments".

  // creates another div element within the comment box with the class name all-comments. This element will contain the individual comments.

  // goes through the comments array using the map function. For each comment object, it calls a callback function that generates the HTML for that comment.


  // (comment, idex) This is the callback function used by the map function. It receives two arguments:  comment: The current comment object being processed.index: The index of the comment in the comments array.

  // className="single-comment">:.   creates a new div element for each comment with the class name single-comment

  // {comment.email} creates a paragraph element displaying the text "Email:" followed by the current comment's email property value.

  // <hr /> creates a line after each comment


    <div className="comment-box">
      <h3>Comments</h3>
      <div className="all-comments">
        {comments.map((comment, index) => (
          <div key={index} className="single-comment">
            <p>Email: {comment.email}</p>
            <p>Comment: {comment.comment}</p>
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};

// exports the CommentBox component so it can be used by other components in your application.
export default CommentBox;
